import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FiTrash2, FiAlertTriangle } from "react-icons/fi";
import { showToast } from "../../../components/common/notification/Notification";

const PostDeleteModal = ({
  show,
  onHide,
  post,
  postService,
  onPostDeleted,
}) => {
  const [deleting, setDeleting] = useState(false);

  if (!show || !post) return null;

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await postService.remove(post.id);
      showToast("Post deleted successfully", { type: "success" });
      if (onPostDeleted) onPostDeleted(post.id);
      onHide();
    } catch (err) {
      console.error("Error deleting post:", err);
      showToast("Failed to delete post", { type: "error" });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton>
        <div className="d-flex align-items-center gap-2">
          <FiAlertTriangle className="text-danger" size={20} />
          <Modal.Title style={{ fontSize: "16px", fontWeight: "700" }}>
            Delete Post
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body style={{ fontSize: "14px", color: "#475569" }}>
        Are you sure you want to delete this requirement post (<strong>{post?.service || `#${post?.id}`}</strong>)? This action cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onHide}
          disabled={deleting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm btn-danger d-inline-flex align-items-center gap-1"
          onClick={handleDelete}
          disabled={deleting}
        >
          <FiTrash2 size={14} />
          <span>{deleting ? "Deleting..." : "Delete"}</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PostDeleteModal;
